import { BASE_PATH } from "@/constants/app.mjs"

interface LogoConfig {
  srcLight: string
  srcDark: string
  alt: string
}

function createCustomerLogo(baseName: string, name: string): LogoConfig {
  const basePath = `${BASE_PATH}/static/images/marketing/home/logos/`
  return {
    srcLight: `${basePath}${baseName}-grayscale-on-light.svg`,
    srcDark: `${basePath}${baseName}-grayscale-on-dark.svg`,
    alt: name,
  }
}

function _createChainLogo(filename: string, name: string): LogoConfig {
  const src = `${BASE_PATH}/static/images/marketing/app-partnership/logos/${filename}`
  return {
    srcLight: src,
    srcDark: src, // Chain logos use same logo for both themes
    alt: name,
  }
}

function _createProtocolLogo(filename: string, name: string): LogoConfig {
  const src = `${BASE_PATH}/static/images/marketing/logos/${filename}`
  return {
    srcLight: src,
    srcDark: src, // Protocol logos use same logo for both themes
    alt: name,
  }
}

export const productPageLogos = {
  explorer: [
    createCustomerLogo("morgan-stanley", "Morgan Stanley"),
    createCustomerLogo("bitwise", "Bitwise"),
    createCustomerLogo("bloomberg", "Bloomberg"),
    createCustomerLogo("franklin-templeton", "Franklin Templeton"),
    createCustomerLogo("standard-chartered", "Standard Chartered"),
  ],
  api: [
    createCustomerLogo("nansen", "Nansen"),
    createCustomerLogo("messari", "Messari"),
    createCustomerLogo("coingecko", "CoinGecko"),
    createCustomerLogo("vaneck", "VanEck"),
    createCustomerLogo("harvard-business", "Harvard Business School"),
  ],
  sheets: [
    createCustomerLogo("morgan-stanley", "Morgan Stanley"),
    createCustomerLogo("bitwise", "Bitwise"),
    createCustomerLogo("bloomberg", "Bloomberg"),
    createCustomerLogo("franklin-templeton", "Franklin Templeton"),
    createCustomerLogo("standard-chartered", "Standard Chartered"),
  ],
  datashare: [
    createCustomerLogo("google", "Google"),
    createCustomerLogo("market-vector", "MarketVector"),
    createCustomerLogo("polkadot", "Polkadot"),
    createCustomerLogo("messari", "Messari"),
    createCustomerLogo("cf-benchmarks", "CF Benchmarks"),
  ],
  integrations: [
    createCustomerLogo("binance", "Binance"),
    createCustomerLogo("bloomberg", "Bloomberg"),
    createCustomerLogo("google", "Google"),
    createCustomerLogo("coingecko", "CoinGecko"),
    createCustomerLogo("messari", "Messari"),
  ],
  dataPartnerships: [
    createCustomerLogo("ethereum", "Ethereum"),
    createCustomerLogo("base", "Base"),
    createCustomerLogo("polkadot", "Polkadot"),
    createCustomerLogo("tron", "Tron"),
    createCustomerLogo("aave", "Aave"),
  ],
  studio: [
    createCustomerLogo("bitwise", "Bitwise"),
    createCustomerLogo("dragonfly", "Dragonfly"),
    createCustomerLogo("pantera", "Pantera"),
    createCustomerLogo("jeffries", "Jefferies"),
    createCustomerLogo("vaneck", "VanEck"),
  ],
  indexes: [
    createCustomerLogo("cf-benchmarks", "CF Benchmarks"),
    createCustomerLogo("market-vector", "MarketVector"),
    createCustomerLogo("bitwise", "Bitwise"),
  ],
  mcp: [
    createCustomerLogo("morgan-stanley", "Morgan Stanley"),
    createCustomerLogo("bitwise", "Bitwise"),
    createCustomerLogo("bloomberg", "Bloomberg"),
    createCustomerLogo("franklin-templeton", "Franklin Templeton"),
    createCustomerLogo("standard-chartered", "Standard Chartered"),
  ],
  research: [
    createCustomerLogo("coinshares", "CoinShares"),
    createCustomerLogo("consensys", "Consensys"),
    createCustomerLogo("ondo", "Ondo"),
    createCustomerLogo("sky", "Sky"),
    createCustomerLogo("morpho", "Morpho"),
  ],
}
